import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { checkRootExisted } from "../../../redux/fui";
import {
  StyledTooltip, StyledParagraphBold, TextWrapper, StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
} from "../FuiStyles";
import { longTextEndDate, rootExistedHint, rootWrongFormatHint } from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import { checkServiceNowTicket, checkRITM, checkOpportunityID, checkWBSECode, checkPOCname, checkEmailFormat, createMaxDate } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions } from "@material-ui/core";
import priceConfig from "./pricetotierMapping";
import { CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';

/**
 * Automatic Ticket Resolver Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */

const AutomaticTicketResolver = ({
  values, // the value would be changed by user's input
  updateATRForm, //the function to update DPForm values which is from redux
  createdBy, // user's EID
  checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
  isRootExist, // the value that show whether DomainContextRoot exist or not from redux
  setIsAllValid, // the function to check whether all validations are satisfieds
  selectedEnvironment,
  minDate,
  maxDate,
  isServiceEndDateInvalid,
  getSelectedEnvironment,
  getServiceEndDate,
  getNotesValue,
  notesValidations,
  configurationType,
  classes,
  history,
  email,
  idToken,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  formClickSubmit,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {
  // open the dialog when user choose Yes in GDPR
  const config = configurationType === "quick";

  //check whether RITM is valid
  const [isRITMValid, setIsRITMValid] = useState(true);
  const [ritmAPIValidation, setRITMAPIValidation] = useState(null);

  //check whether OpportunityID is valid
  const [isOpportunityIDValid, setIsOpportunityIDValid] = useState(true);
  const [opportunityAPIValidation, setOpportunityAPIValidation] = useState(null);

  // check whether WBSECode and MonthlyTicketVolume are valid
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  // check whether WBSECode is equal to MD & I WBSE
  const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isDialogFlowDevToken, setIsDialogFlowDevToken] = useState(false);
  const [isDialogFlowClientToken, setIsDialogFlowClientToken] = useState(false);
  //   const [isUsersFieldValid, setUsersField] = useState(false);
  const [isNoteVisible, setNoteVisible] = useState(true);
  const [isAtrVersionSelected, setIsAtrVersionSelected] = useState(true);

  const isGDPR = values.GDPR === "yes";
  const isOpenAI = values.OpenAI === "True";
  const isEnableQuasar = values.EnableQuasar === "True";
  const isDedicated = values.InstanceType === history.location.state.InstanceType;
  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
  const isDialogFlow = values.DialogFlow === "enabled";
  //   const isPaymentRate = values.PaymentRate === "payasyougo";
  const instanceType = history.location.state.InstanceType;
  const Tier = instanceType && instanceType == "Container" ? values.Tier === '' ? 'gold' : values.Tier : values.Tier


  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [domainContextRoot, setDomainContextRoot] = useState("[__]");
  const [regionCode, setRegionCode] = useState("[__]");
  const [errorADGroup, setErrorADGroup] = useState(false);
  const [errorSADGroup, setErrorSADGroup] = useState(false);
  //check if Admin Distribution Group & Super Admin Distribution Group same
  const [isADSADUnique, setIsADSADUnique] = useState(false);
  const [gptVersion, setGptVersion] = useState("aiops-deployment");
  const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [env, setEnv] = useState("");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);

  // Enhanced validation with borders and dialog
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);

  const [isChecked, setIsChecked] = useState(true);

  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    // updateATRForm("IsContractIdAvailable", value);
    if (value === "no") {
      updateATRForm("IsContractIdAvailable", "no")
      updateATRForm("SAPContractID", "0000000000")
      updateATRForm("EndToEndUId", "")
      updateATRForm("ContractAvailabilityDate", createMaxDate(14));
      setSapContractCodeLength(10)
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updateATRForm("SAPContractID", "")
      updateATRForm("ClientName", "")
      updateATRForm("EndToEndUId", "")
      setSapContractCodeLength(0)
    }
  };


  useEffect(() => {
    if (config) {
      setDomainContextRoot("[__]");
      setRegionCode("[__]");
    }
  }, [config]);


  if (config) {
    //updateATRForm("ClientName", "")
    updateATRForm("EndToEndUId", "")
    updateATRForm("Company", "")
    updateATRForm("AvanadeCountry", "")
    updateATRForm("AccentureCountry", "")
    updateATRForm("InstanceType", history.location.state.InstanceType)
    // updateATRForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
    updateATRForm("Tier", Tier)
    updateATRForm("ContractAvailabilityDate", "")
  }

  if (!config) {
    if (externalClientData.length > 0) {
      updateATRForm("ClientName", externalClientData[0])
      updateATRForm("EndToEndUId", externalClientData[1])
      updateATRForm("InstanceType", history.location.state.InstanceType)
      // updateATRForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
      updateATRForm("Tier", Tier)
      if (externalClientData[2] !== undefined)
        updateATRForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updateATRForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updateATRForm("AccentureCountry", externalClientData[4])
      if (isChecked && externalClientData[5] !== undefined) {
        if (values.GDPR === 'no')
          updateATRForm("GDPR", externalClientData[5] ? "yes" : "no")
      }
      updateATRForm("ContractAvailabilityDate", "")
      updateATRForm("IsContractIdAvailable", "yes")
    } else {
      updateATRForm("InstanceType", history.location.state.InstanceType)
      // updateATRForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
      updateATRForm("Tier", Tier)
    }
  }

  if (!config) {
    if (isDialogFlow) {
      (isDialogFlowClientToken &&
        isDialogFlowDevToken) &&
        !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isRITMValid && isOpportunityIDValid && isProjectNameValid && !errorADGroup && !errorSADGroup && !isADSADUnique && isTeamNameSelected && isPocvalid
        ? setIsAllValid(true)
        : setIsAllValid(false);
    } else {
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isRITMValid && isOpportunityIDValid && isProjectNameValid && !errorADGroup && !errorSADGroup && !isADSADUnique && isTeamNameSelected && isPocvalid
        ? setIsAllValid(true)
        : setIsAllValid(false);
    }
  } else {
    (isRITMValid) &&
      !isServiceEndDateInvalid && isWBSEValid && isProjectNameValid && !errorADGroup && !errorSADGroup && !isADSADUnique && isTeamNameSelected
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  // user can only input lower case letter and numbers in DomainContextRoot
  const handleChangeRoot = (event, fieldName) => {
    const re = /^[a-z0-9]*$/;
    const value = event.target.value;
    re.test(value) && updateATRForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeRootSuggestions = (event, value, fieldName) => {
    const re = /^[a-z0-9]*$/;
    // const value = event.target.value;
    re.test(value) && updateATRForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateATRForm(fieldName, value);
  };

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
      updateATRForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateATRForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateATRForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    } else {
      const { value } = event.target;
      event.preventDefault();
      updateATRForm(fieldName, value);
      if (fieldName === "Environment") {
        setEnv(value); // Sync the local env state with the selected value
        getSelectedEnvironment(value);
      }
      if (fieldName === "WBSEcode") {
        const wbsevalue = value.toUpperCase()
        if (wbsevalue.trim() === "CBYDQ001") {
          setIsWBSECodeMDIValid(false)
        }
        // setIsWBSECodeValid(checkWBSECode(value));
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "RITM") {
        setIsRITMValid(checkRITM(value));
      }
      if (fieldName === "OpportunityID") {
        setIsOpportunityIDValid(checkOpportunityID(value));
      }
      if (fieldName === "AdminDistributionGroup") {
        if (value == values.SuperAdminDistributionGroup) {
          setIsADSADUnique(true)
        } else {
          setIsADSADUnique(false)
        }
        if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
          setErrorADGroup(true)
        } else {
          setErrorADGroup(false)
        }
      }
      if (fieldName === "SuperAdminDistributionGroup") {
        if (value == values.AdminDistributionGroup) {
          setIsADSADUnique(true)
        } else {
          setIsADSADUnique(false)
        }
        if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
          setErrorSADGroup(true)
        } else {
          setErrorSADGroup(false)
        }
      }
      if (fieldName === "DialogFlowDevToken") {
        if (value.length > 0) {
          setIsDialogFlowDevToken(true);
        } else {
          setIsDialogFlowDevToken(false);
        }
      }
      if (fieldName === "DialogFlowClientToken") {
        if (value.length > 0) {
          setIsDialogFlowClientToken(true);
        } else {
          setIsDialogFlowClientToken(false);
        }
      }
      // if (fieldName === "Environment") {
      //   getSelectedEnvironment(value);
      // }
      // if (fieldName === "InstanceType") {
      //   if (value == "Dedicated") {
      //   } else {
      //     updateATRForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL);
      //   }
      // }
      if (fieldName === "TentativeServiceEndDate") {
        getServiceEndDate(value);
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }
      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "OpenAI") {
        if (instanceType === "Dedicated") {
          if (event.target.checked === false) {
            updateATRForm(fieldName, "False");
          } else {
            updateATRForm(fieldName, "True");
          }
        } else {
          updateATRForm(fieldName, value);
        }
      }
      if (fieldName === "GDPR" && value === "yes") {
        updateATRForm("DeploymentRegion", "");
      }
      if (fieldName === "DeploymentRegion") {
        if (value == "sydney") {
          setRegionCode("dh")
        } else if (value == "virginia") {
          setRegionCode("dh1")
        } else if (value == "frankfurt") {
          setRegionCode("dh2")
        } else if (value == "singapore") {
          setRegionCode("dh3")
        } else if (value == "tokyo") {
          setRegionCode("dh4")
        } else if (value == "ireland") {
          setRegionCode("dh5")
        } else if (value == "london") {
          setRegionCode("dh6")
        } else {
          setRegionCode("[__]")
        }
      }
      if (fieldName === "ChatGPT") {
        updateATRForm(fieldName, value);
        setGptVersion(value);
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("") // Clear environment so user can choose Dev or Test
          updateATRForm("DeploymentPhase", "") // Clear DeploymentPhase so user can choose
          updateATRForm("Tier", "")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updateATRForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updateATRForm("Tier", "")
        } else {
          setEnv("")
          updateATRForm("Tier", "")
        }
      }
    }
  };

  updateATRForm("ConfigurationType", configurationType);
  getSelectedEnvironment(env);
  updateATRForm("Environment", env);


  // it would check whether the root has existed from DB once user stop typing longer than 0.3s
  const debouncedValue = useDebounce(domainContextRoot, 300);
  useEffect(() => {
    debouncedValue && checkDomainAvaliable(debouncedValue);
  }, [debouncedValue]);


  //form validation
  const validateInputFields = (step) => {
    // Only validate on final submit (step 2) or when explicitly called with 'submit'
    if (step !== 'step2' && step !== 'submit') {
      return true; // Skip validation for intermediate steps
    }

    let ispass = true;
    const missingFields = [];

    // Collect all required fields for final validation
    let allRequiredFields = [
      'ProjectName',
      'WBSEcode',
      'SecondaryPOC',
      'DataClassification',
      'TeamName',
      'RequestNotes',
      'DeploymentRegion',
      'DomainContextRoot',
      'Environment',
      'AdminDistributionGroup',
      'TentativeServiceEndDate'
    ];

    // Add conditional fields based on configuration
    if (!config) {
      if (isChecked) {
        allRequiredFields.push('SAPContractID');
      } else {
        allRequiredFields.push('Pocdetails', 'ClientName');
      }

      // RITM is always mandatory, OpportunityID is now optional
      allRequiredFields.push('RITM');
      // Add DeploymentPhase for full configuration
      allRequiredFields.push('DeploymentPhase');
    } else {
      // Quick config only requires RITM
      allRequiredFields.push('RITM');
    }

    if (isOpenAI) {
      allRequiredFields.push('SuperAdminDistributionGroup');
      if (instanceType === 'Dedicated') {
        allRequiredFields.push('ChatGPT', 'OpenAITextEmbeddingsModel');
      }
    }

    if (values['Environment'] === "Production") {
      allRequiredFields.push('Tier');
    }

    if (isDialogFlow) {
      allRequiredFields.push('DialogFlowDevToken', 'DialogFlowClientToken');
    }

    if (instanceType !== "Dedicated") {
      allRequiredFields.push('OpenAI');
      if (values.OpenAI === "OpenAI+Quasar") {
        allRequiredFields.push('OpenAITextEmbeddingsModel', 'SuperAdminDistributionGroup');
      }
    }

    // Check each required field
    for (const fieldname of allRequiredFields) {
      let isFieldInvalid = false;

      if (fieldname === "WBSEcode" && (!values[fieldname] || values[fieldname] === "" || !isWBSEValid)) {
        isFieldInvalid = true;
        if (!values[fieldname] || values[fieldname] === "") {
          missingFields.push(fieldname); // Just field name for empty field
        } else if (!isWBSEValid) {
          missingFields.push(`${fieldname} (Invalid WBSE code)`); // Specific message for invalid code
        }
      } else if (fieldname === "RITM") {
        if (!values.RITM || values.RITM === "" || values.RITM === null) {
          isFieldInvalid = true;
          missingFields.push(fieldname);
        } else if (ritmAPIValidation === false) {
          isFieldInvalid = true;
          missingFields.push(`${fieldname} (not found in records)`);
        } else if (!isRITMValid) {
          isFieldInvalid = true;
          missingFields.push(`${fieldname} (invalid format)`);
        }
      } else if (fieldname === "OpportunityID") {
        // OpportunityID is optional, but if provided, it must be valid
        if (values.OpportunityID && values.OpportunityID !== "" && values.OpportunityID !== null) {
          if (opportunityAPIValidation === false) {
            isFieldInvalid = true;
            missingFields.push(`${fieldname} (not found in records)`);
          } else if (!isOpportunityIDValid) {
            isFieldInvalid = true;
            missingFields.push(`${fieldname} (invalid format)`);
          }
        }
      } else if (fieldname === 'DialogFlowDevToken' || fieldname === 'DialogFlowClientToken') {
        // Special handling for DialogFlow tokens - either one is sufficient
        if (values['DialogFlowDevToken'] === "" && values['DialogFlowClientToken'] === "") {
          if (!missingFields.find(field => field.startsWith('DialogFlow'))) {
            missingFields.push('DialogFlow tokens (At least one required)');
          }
          ispass = false;
        }
      } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
        // TentativeServiceEndDate requires environment to be selected first
        isFieldInvalid = true;
        missingFields.push(fieldname);
      } else if (fieldname === "Pocdetails") {
        if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
          missingFields.push(fieldname);
          ispass = false;
        }
      } else if (fieldname === "SecondaryPOC") {
        // For SecondaryPOC, validate as email in full config mode
        if (!values.SecondaryPOC || values.SecondaryPOC === "") {
          isFieldInvalid = true;
          missingFields.push(fieldname);
        } else if (!config && !checkEmailFormat(values.SecondaryPOC)) {
          // In full config mode, SecondaryPOC should be a valid email (Client Project Requester Email ID)
          isFieldInvalid = true;
          missingFields.push(`${fieldname} (Invalid email format)`);
        }
      } else if (!values[fieldname] || values[fieldname] === "") {
        isFieldInvalid = true;
        missingFields.push(fieldname);
      }

      if (isFieldInvalid) {
        ispass = false;
      }
    }

    // Use the new validation handler
    handleValidationResult(ispass, missingFields, formClickSubmit);

    return ispass;
  }

  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={1}
        validateInputFields={validateInputFields}
        ClientContractFields={

          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a Contract ID available?
                </ConfigurationFormLabel>


                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""}

            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 42 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }
            < div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }
                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    <StyledTooltip
                      title={longTextEndDate}
                      placement="left-start"
                      noValidate
                    >
                      <DateTextFieldCommonComponentv2
                        tentativeServiceEndDate={values.ContractAvailabilityDate}
                        minDate={0}
                        maxDate={createMaxDate(27)}
                        handleChange={handleChange}
                        idkey="ContractAvailabilityDate"
                        label="Contract Availability Date"
                      />
                    </StyledTooltip>
                  </Grid>
                }
                {(!config) &&
                  <>
                    <Grid item xs={4}>
                      <FormField.RITMField
                        values={values}
                        handleChange={handleChange}
                        isRITMValid={isRITMValid}
                        apiValidation={ritmAPIValidation}
                        setAPIValidation={setRITMAPIValidation}
                        configurationType={configurationType}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormField.OpportunityIDField
                        values={values}
                        handleChange={handleChange}
                        isOpportunityIDValid={isOpportunityIDValid}
                        apiValidation={opportunityAPIValidation}
                        setAPIValidation={setOpportunityAPIValidation}
                        configurationType={configurationType}
                      />
                    </Grid>
                  </>
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >}

                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>

                {config &&
                  <Grid item xs={8}>
                    <FormField.RITMField
                      values={values}
                      handleChange={handleChange}
                      isRITMValid={isRITMValid}
                      apiValidation={ritmAPIValidation}
                      setAPIValidation={setRITMAPIValidation}
                      configurationType={configurationType}
                    />
                  </Grid>
                }
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                </Grid >
                <Grid item xs={4}>
                  {FormField.SecondaryContact(handleChange, values, config)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                {!config && (
                  <Grid item xs={4}>
                    {FormField.DeploymentPhaseField(handleChange, values, env)}
                  </Grid>
                )}
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected, 'gtaad', configurationType, instanceType)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                {
                  (config &&
                    <Grid item xs={4}>
                      {FormField.ClientNamePlatformInternal(handleChange, values)}
                    </Grid>
                  )
                }
                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    values,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            {!config ? <p> Expected Custom URL: <span style={{ color: " #0041F0" }}>https://{regionCode}.{domainContextRoot}.mywizard-aiops.com</span></p> : ""}
            {!config && isEnableQuasar ? <p> Expected Quasar Custom URL: <span style={{ color: "#0041F0" }}>https://{regionCode}-{domainContextRoot}quasar.mywizard-aiops.com</span></p> : ""}
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                <Grid item xs={12}>
                  {PlatformFormField.GDPRPlatformField(
                    values,
                    handleChange,
                    isGDPR,
                    classes,
                    config,
                    isChecked,
                    externalClientData
                  )}
                </Grid>
                <Grid item xs={3}>
                  {PlatformFormField.DeploymentRegionATRPlatformField(
                    values,
                    handleChange,
                    isGDPR,
                    isDedicated,
                    isOpenAI,
                    instanceType,
                    values.TeamName,
                    configurationType
                  )}
                </Grid>
                <Grid item xs={6}>
                  {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                    values,
                    handleChangeRootSuggestions,
                    // handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    rootWrongFormatHint,
                    externalClientData,
                    domainContextRoot,
                    isLoading
                  ) : PlatformFormField.DomainContextRootPlatformField(
                    values,
                    handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    isLoading
                  )}
                </Grid>
                {/* <Grid item xs={3}>
                  {PlatformFormField.EnvironmentPlatformField(values, handleChange)}
                </Grid> */}
                <Grid item xs={3}>
                  {values.DataClassification === "Client-NonProduction"
                    ? PlatformFormField.EnvironmentClientNonProdField(values, handleChange)
                    : PlatformFormField.EnvironmentField(values, handleChange, env)}
                </Grid>
                {/* {values.Environment === "Production" && ( */}
                  <>
                    {/* <Grid item xs={3}>
                      {PlatformFormField.AtrTierPlatformField(
                        values,
                        handleChange
                      )}
                      {values.Tier && ( */}
                      {/* /</div> */}
                      {/* )} */}
                    {/* </Grid> */}
                  </>
                {/* )} */}
              </Grid>
            </div>
          </div>
        }

        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              {/* <Grid item xs={6}>
                {PlatformFormField.InstanceTypePlatformField(
                  values,
                  handleChange,
                  isDedicated,
                  classes
                )}
              </Grid> */}

              <Grid item xs={6}>
                {FormField.AdminDistributionGroupFieldATR(handleChange, values, errorADGroup, isADSADUnique)}
              </Grid>
              <Grid item xs={6}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
              {/* <Grid item xs={4}>
                {FormField.ATRVersionSelect(handleChange, values, isAtrVersionSelected)}
              </Grid> */}
              <Grid item xs={4}>
                {FormField.DialogFlowField(handleChange, values, isDialogFlow)}
              </Grid>
              <Grid item xs={4}>

              </Grid>
              {isDialogFlow &&
                <Grid item xs={6}>{FormField.DialogFlowDevTokenField(handleChange, values)}</Grid>}
              {isDialogFlow &&
                <Grid item xs={6}>{FormField.DialogFlowClientTokenField(handleChange, values)}</Grid>}
              {instanceType === "Dedicated" ?
                <Grid item xs={6}>
                  {FormField.OpenAIFieldATR(handleChange, values, isOpenAI)}
                </Grid>
                :
                <Grid item xs={6}>
                  {FormField.GenwizardIntegrationField(handleChange, values)}
                </Grid>
              }
              <Grid item xs={6}>

              </Grid>
              {values.OpenAI === "OpenAI+Quasar" &&
                <>
                  <Grid item xs={6}> {FormField.OpenAITextEmbeddingsModel(handleChange, values)}</Grid>
                  <Grid item xs={6}> {FormField.SuperAdminDistributionGroupField(handleChange, values, errorSADGroup, isADSADUnique)}</Grid>
                </>
              }

              {/* {isOpenAI || isEnableQuasar ? */}
              {/* <Grid item xs={3}> {FormField.ChatGPTFieldForATR(handleChange, values)}</Grid> : ""} */}
              {instanceType === "Dedicated" ? <Grid item xs={4}>
                {isOpenAI ? FormField.ChatGPTFieldForQuasar(handleChange, values) : ""}
              </Grid> : ""
              }

              {instanceType === "Dedicated" ? <Grid item xs={4}>
                {isOpenAI ? FormField.OpenAITextEmbeddingsModel(handleChange, values) : ""}
              </Grid> : ""
              }

              {
                isOpenAI ? <Grid item xs={4}>{FormField.SuperAdminDistributionGroupField(handleChange, values, errorSADGroup, isADSADUnique)}</Grid>
                  : ""
              }

              {/* <Grid item xs={6}> */}
              {/* {isOpenAI && gptVersion && PlatformFormField.DeploymentRegionFieldForATR(handleChange, values, gptVersion, isGDPR, isDedicated)} */}
              {/* {PlatformFormField.DeploymentRegionATRPlatformField(
                  values,
                  handleChange,
                  isGDPR,
                  isDedicated
                )} */}
              {/* </Grid> */}
              {/* if user select enable in DialogFlow, it would show DialogFlowDevToken with default value */}

              {/* <Grid item xs={6}>
                {FormField.AdminDistributionGroupFieldATR(handleChange, values, errorADGroup)}
              </Grid> */}
              {/* <Grid item xs={6}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid> */}
            </Grid>
          </div>
        }
        LeftColumnFields={
          <div>
          </div>
        }
        RightColumnFields={
          <div>
          </div>
        }
        history={history}
      ></GeneralForm>
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions>
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
      />
    </>
  );
};

const MSTP = (state, ownProps) => ({
  values: state.fui.ATRForm,
  isRootExist: state.fui.isRootExist,
  isWBSEValid: state.fui.isWBSEValid,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
  checkDomainAvaliable: checkRootExisted,
  updateATRForm: fuiRedux.updateATRForm,
  fetchExternalClientDetails,
  checkIsWBSEValid,
})(withRouter(AutomaticTicketResolver));
